module.exports = __webpack_public_path__ + "static/media/16UNODC12.ce501ab4.jpg";